import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
  {
    id: 1,
    projectName: "SkinStore.com Clone",
    projectDesc:
      " SkinStore is an authorized retailer to 100s of premium beauty brands. It is end-to-end tech platform specializing in taking brands direct to consumers across the globe. here I implemented some functionalities like Login,SignUp, Checkout, etc.",
    tags: ["HTML", "CSS", "Javascript"],
    code: "https://github.com/Swapnilk98/SkinStore-",
    demo: "https://epic-swanson-c038fa.netlify.app/",
    image: "https://miro.medium.com/max/1400/0*575YDvBGKuY33nBG.png",
  },
  {
    id: 2,
    projectName: "Frontend Masters.com Clone",
    projectDesc:
      "This website is a learning platform where you can learn Frontend courses.A web application to buy premium As well as Free frontend courses.here I implemented some Functionalities like real time Search with Debounce,Login,Courses etc.",
    tags: ["HTML", "CSS", "Javascript,API"],
    code: "https://github.com/Swapnilk98/Frontend-Master",
    demo: "https://zingy-cactus-84c80d.netlify.app/",
    image: "https://miro.medium.com/max/700/0*SLWKKczIzUpDcjGI.png",
  },
  {
    id: 3,
    projectName: "Nordstromrack Website  Clone",
    projectDesc:
      "This project is the clone of Nordstromrack it is a leading fashion retailer offering compelling clothing, shoes and accessories for men, women and kids. I implemented some functionalities product searching ,sorting & filtering, add to cart etc.",
    tags: ["React", "Material UI", "Redux", "React-Bootstrap"],
    code: "https://github.com/Swapnilk98/rack",
    demo: "https://precious-lokum-c13ef5.netlify.app/",
    image: "https://miro.medium.com/max/700/0*EpD9LokMd0ldUdzH.png",
  },
  {
    id: 3,
    projectName: "Everhour.com Clone",
    projectDesc:
      "Everhour is an app that calculates your work hours, the work hours of your team, or a particular team member and collaborate this data together into handy detailed reports",
    tags: ["React", "Chakra UI", "Redux", "Express", "MongoDB"],
    code: "https://github.com/Swapnilk98/smooth-dock-1057",
    demo: "https://everhour.netlify.app/",
    image: "https://i.ibb.co/yqKhWy5/Screenshot-303.png",
  },
];


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/